import { render, staticRenderFns } from "./SelectInputForms.vue?vue&type=template&id=2706e5b7&scoped=true&"
import script from "./SelectInputForms.vue?vue&type=script&lang=js&"
export * from "./SelectInputForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706e5b7",
  null
  
)

export default component.exports